import React from "react";
import type { Para } from "../../data/caseStudies";
import { BODY, H3 } from "../../utils/typography";
type ProseProps = {
  body: Para[];
  className?: string;
  emphasisClassName?: string;
};
export function Prose({
  body,
  className = `${BODY} text-espresso/80`,
  emphasisClassName = `${H3} text-espresso`
}: ProseProps) {
  return <div className="space-y-5" data-id="element-84" data-mp="yt29vggjj562">
      {body.map((para, i) => typeof para === "string" ? <p key={i} className={className} data-id="element-85" data-mp="12t2op27jxidn">
            {para}
          </p> : <p key={i} className={emphasisClassName} data-id="element-86" data-mp="17qmb4peel1go">
            {para.emphasis}
          </p>)}
    </div>;
}